import React from 'react';
import PropTypes from 'prop-types';

import {
  Chip,
  IconButton,
  Menu,
  MenuItem,
  Snackbar,
  Typography,
} from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';

import {
  Close as CloseIcon,
  FiberManualRecord as ObjectIcon,
  OpenInNew as ExtLinkIcon,
  ListAlt as DataIcon,
  PhotoLibrary as ArtifactsIcon,
  Pageview as SamplesIcon,
  BugReport as DiagnosticsIcon,
} from '@material-ui/icons';

import { CopyToClipboard } from 'react-copy-to-clipboard';

import { BucketIcon } from '../../aws';

import { 
  fmtBytes,
  fmtS3ConsoleLink,
} from '../../utils/formatters';

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: '8px',
    whiteSpace: 'normal',
    height: 'auto',
  },
  label: {
    paddingTop: '4px',
    paddingBottom: '4px',
    width: 'calc(100% - 58px)',
    whiteSpace: 'normal',
  },
  info: {
    display: 'flex',
    flexFlow: 'column',
  },
  name: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  description: {
  },
  typography: {
  }
}));

export default function ExecutionOutputChip(props) {
  const { type, count, size, location, maxWidth, showZero } = props;
  const classes = useStyles();

  const [menuAnchor, setMenuAnchor] = React.useState(null);
  const [actionMessage, setActionMessage] = React.useState("");

  const href = location?fmtS3ConsoleLink(location):null;

  const handleExtLink = () => {
    window.open(href,"_blank");
    handleCloseMenu();
  };

  const handleClick = (event) => {
    setMenuAnchor(event.currentTarget);
  };
  
  const handleCloseMenu = () => {
    setMenuAnchor(null);
  };

  const handleActionPerformed = (message) => {
    setActionMessage(message);
    handleCloseMenu();
  };

  const clearActionMessage = () => {
    setActionMessage("");
  };


  if(!count || (count===0 && !showZero)) {
    return(null);
  }
  
  let TypeIcon=ObjectIcon;
  switch (type) {
    case 'Data':
      TypeIcon=DataIcon;
      break;
    case 'Artifacts':
      TypeIcon=ArtifactsIcon;
      break;
    case 'Samples':
      TypeIcon=SamplesIcon;
      break;
    case 'Diagnostics':
      TypeIcon=DiagnosticsIcon;
      break;
    default:
      break;
  }

  return (
    <React.Fragment>
      <Chip
        classes={{ root: classes.root, label: classes.label }}
        variant="outlined"
        icon=<TypeIcon/>
        label={
          <div className={classes.info}>
            <div className={classes.name}>
              <Typography className={classes.typography} variant='inherit' color='primary'>
                {type}
              </Typography>
            </div>
            <div className={classes.description}>
              <Typography className={classes.typography} variant='inherit' >
                {fmtBytes(size)} in {count} object{count===1?'':'s'}
              </Typography>
            </div>
          </div>
        }
        onClick={handleClick}
        onDelete={handleExtLink}
        deleteIcon={<BucketIcon titleAccess="View in S3..."/>}
        style={{ maxWidth }}
      />
      <Menu
        id="action-menu"
        anchorEl={menuAnchor}
        keepMounted
        open={Boolean(menuAnchor)}
        onClose={handleCloseMenu}
      >
        <CopyToClipboard 
            text={location} 
            onCopy={() => handleActionPerformed('S3 Location URI copied to clipboard')}>
          <MenuItem>Copy S3 URI...</MenuItem>
        </CopyToClipboard>
        <CopyToClipboard 
            text={href} 
            onCopy={() => handleActionPerformed('S3 Console URL copied to clipboard')}>
          <MenuItem>Copy S3 Console URL...</MenuItem>
        </CopyToClipboard>
        <MenuItem onClick={handleExtLink}>View location in S3 Console&nbsp;<ExtLinkIcon fontSize="small"/></MenuItem>
      </Menu>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        open={actionMessage.length>0}
        autoHideDuration={3000}
        onClose={clearActionMessage}
        message={actionMessage}
        action={
          <IconButton size="small" aria-label="close" color="inherit" onClick={clearActionMessage}>
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      />
    </React.Fragment>
  );
}

ExecutionOutputChip.propTypes = {
  type: PropTypes.oneOf(['Outputs', 'Data', 'Artifacts', 'Samples', 'Diagnostics']),
  count: PropTypes.number,
  size: PropTypes.number,
  location: PropTypes.string,
  showZero: PropTypes.bool,
  maxWidth: PropTypes.string,
};

ExecutionOutputChip.defaultProps = {
  type: 'Outputs',
  size: 0,
  showZero: false,
};

